var exports = {
  "H_": "hovercard__VZ64nc",
  "wx": "header__N9B0en",
  "vE": "timestamp__belUua",
  "DD": "title__KY56hA",
  "cL": "metaList__rMPeYS",
  "KW": "metaRow__0OPs7N",
  "t8": "metaIcon__-ojWbc",
  "Mt": "metaValue__oO_KpC",
};

module.exports = exports;
